import { useState } from "react";
import {
  Box,
  Button,
  Input,
  Grid,
  Spacer,
  FlexiPagination,
  Modal,
  ModalBody,
  Loader,
  EmptyState,
} from "@flexisaf/flexibull2";
import DepartmentCard from "./support/departmentCard";
import DepartmentEditor from "./support/departmentEditor";
import useDepartmentsGet from "../../../../hooks/departments/useDepartmentsGet";
import Theme from "../../../../theme";

const Departments = () => {
  const [modal, setModal] = useState({
    show: false,
    data: null,
  });

  const {
    departments,
    loadingDepartments,
    limit,
    setLimit,
    totalElements,
    page,
    setPage,
    pageOptions,
    searchText,
    setSearchText,
  } = useDepartmentsGet();

  const onEdit = (data) => {
    setModal({
      show: true,
      data,
    });
  };

  return (
    <Box>
      <Grid
        default="minmax(auto, 400px)  minmax(auto, 300px) auto max-content max-content"
        sm="1fr"
      >
        <Input
          name="search"
          block
          placeholder="Search Departments"
          iconLeft="saf-search-normal"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <Box />
        <Box />

        <Button
          onClick={() => {
            setModal({
              show: true,
              data: null,
            });
          }}
        >
          Create Department
        </Button>
      </Grid>
      <Spacer space="40px" />
      <>
        {loadingDepartments ? (
          <Box pad="150px 0">
            <Loader color={Theme.PrimaryColor} section height="70vh" />
          </Box>
        ) : departments?.items?.length > 0 ? (
          <>
            <Grid default="1fr 1fr 1fr 1fr" gap="20px">
              {departments?.items?.map((faculty) => {
                return (
                  <DepartmentCard
                    id={faculty.id}
                    name={faculty.name}
                    handleEdit={() => onEdit(faculty)}
                  />
                );
              })}
            </Grid>
            <FlexiPagination
              pageCounts={pageOptions}
              itemsDisplayed
              total={totalElements}
              pageSize={limit}
              onChange={(page) => {
                setPage(page);
              }}
              changePageSize={({ value }) => {
                setPage(1);
                setLimit(value);
              }}
              current={page}
            />
          </>
        ) : (
          <Box align="center">
            <EmptyState type="documents" title="Department not found." />
          </Box>
        )}
        <Modal open={modal.show} center={false}>
          <ModalBody width="600px">
            <DepartmentEditor
              closeModal={() => setModal({ show: false, data: null })}
              data={modal.data}
            />
          </ModalBody>
        </Modal>
      </>
    </Box>
  );
};

export default Departments;
